import '../app.less';
import '../google_account_settings.less';
import '../google_analytics_widget.less';

window.insDashboardApp = angular.module('insDashboardApp',[

    // Putting Anything other than a controller here means that we have not fully moved it over to be modular.
    // Any time we see it in a component we move over, we should check for usage, and if it is safe, remove it from this list.
    'MW.Framework.InformationTypeService',
    'MW.InsDashboard.InsightsCacheConstants',
    'MW.Dashboard.DashboardStateService',
    'MW.DashboardLegacy.Constants',
    'MW.Framework.CoreSearchService',
    'MW.Framework.Breadcrumb',
    'MW.InsDashboard.GoogleAccountSettings'
]);

angular.module('MW.InsDashboard.InsightsCacheConstants', [
    'MW.Framework.MwCacheService'
])
.factory('InsightsCacheConstants', ['CacheConstants', function(CacheConstants) {
    'use strict';
    CacheConstants.set('INS_DATE_SENTIMENT_HISTOGRAM')
        .set('INS_VOLUME')
        .set('INS_DATE_HISTOGRAM')
        .set('INS_DATE_REACH_HISTOGRAM')
        .set('INS_AVG_DATE_HISTOGRAM')
        .set('INS_FAIRHAIR')
        .set('INS_SOURCE_HISTOGRAM')
        .set('INS_COUNTRY_HISTOGRAM')
        .set('INS_REGION_HISTOGRAM')
        .set('INS_DATE_AVE_HISTOGRAM')
        .set('INS_CONSOLIDATED_REQUEST');
    return CacheConstants;
}]);
